import type { FC } from "react";
import { BundleFrame } from "app/components/portal/BundleFrame";

export const PremiumFeaturesHomePageContainer: FC = () => {
    return (
        <BundleFrame
            bundle={"portal"}
            zorder={1049}
        />
    );
};
